import React, { useState, useEffect, useRef } from 'react';
import Layout from '../components/Layout';
import { useEmpresa } from '../context/EmpresaContext';
import api from '../services/api';

export default function Configuracion() {
  const { empresa, actualizar, logoSrc, cargar } = useEmpresa();
  const [form, setForm] = useState({ nombre:'', nit:'', telefono:'', telefono2:'', direccion:'', ciudad:'', email:'', website:'', color_primario:'#00E5FF', pie_factura:'¡Gracias por su preferencia!', mp_access_token:'', gmail_user:'', gmail_app_pass:'', ai_search_url:'', turnstile_site_key:'', turnstile_secret:'', ia_vision_url:'', ia_vision_token:'', ia_vision_modelo:'', analytics_token:'', whatsapp_ventas:'', smtp_host:'', smtp_puerto:'', smtp_remitente:'', envio_tarifa:'', envio_gratis_desde:'', retiro_cargo:'', retiro_sin_cargo_pasando_de:'' });
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);
  const [logoMime, setLogoMime] = useState('image/png');
  const [guardando, setGuardando] = useState(false);
  const [ok, setOk] = useState(false);
  const [error, setError] = useState('');
  const [descargando, setDescargando] = useState(false);
  const [restaurando, setRestaurando] = useState(false);
  const [msgBackup, setMsgBackup] = useState('');
  const inputBackupRef = React.useRef(null);
  const inputLogoRef = useRef(null);

  useEffect(() => {
    if (empresa) {
      setForm({
        nombre: empresa.nombre || '',
        nit: empresa.nit || '',
        telefono: empresa.telefono || '',
        telefono2: empresa.telefono2 || '',
        direccion: empresa.direccion || '',
        ciudad: empresa.ciudad || '',
        email: empresa.email || '',
        website: empresa.website || '',
        color_primario: empresa.color_primario || '#00E5FF',
        pie_factura: empresa.pie_factura || '¡Gracias por su preferencia!',
        /* Ninguna llave se precarga: el servidor ya no las manda de vuelta. Guardar el campo
           vacío conserva la que había, así que dejarlas en blanco no borra nada. */
        mp_access_token: '',
        ai_search_url: empresa.ai_search_url || '',
        turnstile_site_key: empresa.turnstile_site_key || '',
        turnstile_secret: '',
        ia_vision_url: empresa.ia_vision_url || '',
        ia_vision_modelo: empresa.ia_vision_modelo || '',
        ia_vision_token: '',
        gmail_user: empresa.gmail_user || '',
        gmail_app_pass: '',
        // No es secreto: va escrito en la página, así que sí se precarga y se puede ver.
        analytics_token: empresa.analytics_token || '',
        // Tampoco es secreto: es el número que ya está publicado en la tienda.
        whatsapp_ventas: empresa.whatsapp_ventas || '',
        // A dónde se conecta el correo. Nada de esto es secreto, así que se precarga.
        smtp_host: empresa.smtp_host || '',
        smtp_puerto: empresa.smtp_puerto || '',
        smtp_remitente: empresa.smtp_remitente || '',
        /* Cifras de plata: se usa `?? ''` y no `|| ''` porque un cero puesto a propósito
           —apagar el cobro— no puede convertirse en campo vacío al abrir la pantalla. */
        envio_tarifa: empresa.envio_tarifa ?? '',
        envio_gratis_desde: empresa.envio_gratis_desde ?? '',
        retiro_cargo: empresa.retiro_cargo ?? '',
        retiro_sin_cargo_pasando_de: empresa.retiro_sin_cargo_pasando_de ?? '',
      });
    }
  }, [empresa]);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  /**
   * Comprobar que la lectura de fotos quedó bien configurada.
   *
   * Son tres campos que hay que copiar de otra página, y sin esto la única forma de saber si
   * quedaron bien es crear un producto de verdad y ver si falla — con un mensaje del servicio
   * que no dice qué corregir. Esto lo traduce a algo accionable.
   */
  const [probando, setProbando] = useState(false);
  const [msgLectura, setMsgLectura] = useState(null);

  const probarLectura = async () => {
    setProbando(true); setMsgLectura(null);
    try {
      // Se manda lo que está ESCRITO en pantalla. Si se probara solo lo guardado, pegar un
      // token nuevo y probar sin guardar contestaría sobre el token viejo — el mismo error
      // de antes con el token nuevo a la vista, imposible de entender.
      const { data } = await api.post('/api/catalogo/probar-lectura', {
        url: form.ia_vision_url || undefined,
        token: form.ia_vision_token || undefined,
        modelo: form.ia_vision_modelo || undefined,
      });
      setMsgLectura(data);
    } catch (e) {
      setMsgLectura({ ok: false, que_hacer: 'No se pudo probar: ' + (e.response?.data?.error || e.message) });
    }
    setProbando(false);
  };

  /**
   * Probar que los correos salen, sin hacer un pedido de mentiras en la tienda.
   *
   * Los avisos fallaban en silencio: sin la clave del Gmail no salía nada, no quedaba rastro,
   * y un pedido sin aviso se veía igual que uno con aviso. Esto manda un correo de verdad y
   * dice qué corregir — el «Invalid login 535-5.7.8» de Gmail traducido a que hace falta una
   * contraseña de aplicación y no la del correo, que es el error de la primera vez.
   */
  const [probandoCorreo, setProbandoCorreo] = useState(false);
  const [msgCorreo, setMsgCorreo] = useState(null);

  const probarCorreo = async () => {
    setProbandoCorreo(true); setMsgCorreo(null);
    try {
      const { data } = await api.post('/api/configuracion/probar-correo', {});
      setMsgCorreo(data);
    } catch (e) {
      setMsgCorreo({ ok: false, que_hacer: 'No se pudo probar: ' + (e.response?.data?.error || e.message) });
    }
    setProbandoCorreo(false);
  };

  /**
   * Aceptar la licencia del modelo de IA.
   *
   * Los modelos Llama de Meta traen su licencia comunitaria y Cloudflare no los deja usar
   * hasta que la cuenta la acepta. El sistema sabe cómo aceptarla, pero NO lo hace solo:
   * aceptar una licencia es un acto del dueño de la cuenta. Por eso hay un botón que dice
   * qué se está aceptando, y lo pulsa Víctor.
   */
  const [aceptando, setAceptando] = useState(false);

  const aceptarLicencia = async () => {
    if (!window.confirm(
      'Vas a aceptar la Licencia Comunitaria de Meta para el modelo Llama 3.2, a nombre de tu cuenta de Cloudflare.\n\n' +
      'Es gratis y es una sola vez. Sin esto, Cloudflare no deja usar el modelo.\n\n' +
      'La licencia completa está en llama.com/llama3_2/license\n\n¿Aceptas?')) return;
    setAceptando(true); setMsgLectura(null);
    try {
      const { data } = await api.post('/api/catalogo/aceptar-modelo', {
        url: form.ia_vision_url || undefined,
        token: form.ia_vision_token || undefined,
        modelo: form.ia_vision_modelo || undefined,
      });
      setMsgLectura(data);
    } catch (e) {
      setMsgLectura({ ok: false, que_hacer: 'No se pudo: ' + (e.response?.data?.error || e.message) });
    }
    setAceptando(false);
  };

  const onLogo = (archivo) => {
    if (!archivo) return;
    if (archivo.size > 5 * 1024 * 1024) { setError('El logo no debe superar 5MB'); return; }
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target.result.split(',')[1];
      setLogoBase64(base64);
      setLogoMime(archivo.type);
      setLogoPreview(e.target.result);
    };
    reader.readAsDataURL(archivo);
  };

  const eliminarLogo = async () => {
    if (!window.confirm('¿Eliminar el logo actual?')) return;
    try {
      await api.delete('/api/configuracion/logo');
      setLogoPreview(null);
      setLogoBase64(null);
      cargar();
    } catch (e) { setError('Error al eliminar logo'); }
  };

  const guardar = async () => {
    if (!form.nombre) { setError('El nombre de la empresa es requerido'); return; }
    setGuardando(true); setError(''); setOk(false);
    try {
      await actualizar({
        ...form,
        logo_base64: logoBase64 || undefined,
        logo_mime: logoMime,
      });
      setOk(true);
      setTimeout(() => setOk(false), 3000);
    } catch (e) {
      setError('Error al guardar configuración');
    } finally { setGuardando(false); }
  };

  const logoActual = logoPreview || logoSrc;

  const restaurarBackup = async (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    if (!archivo.name.endsWith('.dump')) {
      setMsgBackup('❌ Solo se aceptan archivos .dump generados por este sistema');
      return;
    }
    if (!window.confirm('⚠️ ¿Restaurar este backup? Se reemplazarán TODOS los datos actuales. Esta acción no se puede deshacer.')) return;
    setRestaurando(true); setMsgBackup('');
    try {
      const formData = new FormData();
      formData.append('backup', archivo);
      const token = localStorage.getItem('token');
      const res = await fetch('/api/backup/restaurar', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setMsgBackup('✅ ' + data.mensaje);
    } catch (e) {
      setMsgBackup('❌ Error al restaurar: ' + e.message);
    } finally {
      setRestaurando(false);
      e.target.value = '';
    }
  };

  const descargarBackup = async () => {
    setDescargando(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/backup/descargar', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Error al generar backup');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const fecha = new Date().toISOString().split('T')[0];
      a.download = `linkus-backup-${fecha}.dump`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError('Error al descargar backup: ' + e.message);
    } finally { setDescargando(false); }
  };

  return (
    <Layout>
      <div style={s.header}>
        <div>
          <h1 style={s.titulo}>Configuración</h1>
          <p style={s.sub}>Datos de tu empresa — se aplican en todo el sistema</p>
        </div>
      </div>

      <div style={s.grid}>
        {/* Logo */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>🖼 Logo de la empresa</h3>
          <div style={s.logoArea}>
            {logoActual ? (
              <div style={s.logoPreviewBox}>
                <img src={logoActual} alt="Logo" style={s.logoPreviewImg} />
              </div>
            ) : (
              <div style={s.logoVacio}>
                <span style={{ fontSize:'40px' }}>🏢</span>
                <span style={s.logoVacioText}>Sin logo</span>
              </div>
            )}
            <div style={s.logoBtns}>
              <button style={s.btnSubir} onClick={() => inputLogoRef.current?.click()}>
                📂 {logoActual ? 'Cambiar logo' : 'Subir logo'}
              </button>
              {(logoActual) && (
                <button style={s.btnEliminarLogo} onClick={eliminarLogo}>Eliminar</button>
              )}
            </div>
            <p style={s.logoHint}>PNG o JPG, máximo 2MB. Se muestra en el sidebar, facturas y reportes.</p>
          </div>
          <input ref={inputLogoRef} type="file" accept="image/png,image/jpeg,image/jpg" style={{ display:'none' }}
            onChange={e => { if (e.target.files[0]) onLogo(e.target.files[0]); }} />
        </div>

        {/* Datos principales */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>🏢 Datos de la empresa</h3>
          <div style={s.formGrid}>
            <div style={{ ...s.campo, gridColumn:'1/-1' }}>
              <label style={s.label}>Nombre de la empresa *</label>
              <input style={s.input} value={form.nombre} onChange={e => f('nombre', e.target.value)} placeholder="Nombre completo de la empresa" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>NIT</label>
              <input style={s.input} value={form.nit} onChange={e => f('nit', e.target.value)} placeholder="Ej: 900.123.456-7" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Ciudad</label>
              <input style={s.input} value={form.ciudad} onChange={e => f('ciudad', e.target.value)} placeholder="Ej: Bogotá, Colombia" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Teléfono principal</label>
              <input style={s.input} value={form.telefono} onChange={e => f('telefono', e.target.value)} placeholder="Ej: 601 123 4567" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Teléfono secundario / WhatsApp</label>
              <input style={s.input} value={form.telefono2} onChange={e => f('telefono2', e.target.value)} placeholder="Ej: 310 123 4567" />
            </div>
            <div style={{ ...s.campo, gridColumn:'1/-1' }}>
              <label style={s.label}>Dirección</label>
              <input style={s.input} value={form.direccion} onChange={e => f('direccion', e.target.value)} placeholder="Dirección de la empresa" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Correo electrónico</label>
              <input style={s.input} type="email" value={form.email} onChange={e => f('email', e.target.value)} placeholder="contacto@empresa.com" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Sitio web</label>
              <input style={s.input} value={form.website} onChange={e => f('website', e.target.value)} placeholder="www.empresa.com" />
            </div>
          </div>
        </div>

        {/* Personalización */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>🎨 Personalización</h3>
          <div style={s.formGrid}>
            <div style={s.campo}>
              <label style={s.label}>Color principal del sistema</label>
              <div style={s.colorRow}>
                <input type="color" value={form.color_primario} onChange={e => f('color_primario', e.target.value)} style={s.colorPicker} />
                <input style={{ ...s.input, flex:1 }} value={form.color_primario} onChange={e => f('color_primario', e.target.value)} placeholder="#00E5FF" />
              </div>
            </div>
            <div style={{ ...s.campo, gridColumn:'1/-1' }}>
              <label style={s.label}>Pie de página en facturas y recibos</label>
              <input style={s.input} value={form.pie_factura} onChange={e => f('pie_factura', e.target.value)} placeholder="Ej: ¡Gracias por su preferencia!" />
            </div>
            <div style={{ gridColumn:'1/-1', marginTop:'8px', padding:'14px', background:'rgba(0,158,227,0.06)', border:'1px solid rgba(0,158,227,0.2)', borderRadius:'10px' }}>
              <label style={{...s.label, color:'#4FC3F7'}}>💳 Mercado Pago — Access Token (pago en línea en la tienda web)</label>
              <input style={s.input} type="password" autoComplete="off" name="linkus_mp_access_token" value={form.mp_access_token} onChange={e => f('mp_access_token', e.target.value)} placeholder={empresa?.tiene_mp_access_token ? 'Ya hay una guardada — escribe una nueva solo si la vas a cambiar' : 'APP_USR-...'} />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>Se obtiene en mercadopago.com.co → Tus integraciones → Credenciales de producción. Se activa al guardar, sin reiniciar nada.</div>

              {/* El buscador conversacional de la tienda. Se guarda aquí y no en el código
                  para que cambiar de instancia en Cloudflare no obligue a un despliegue. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>💬 Buscador por preguntas — dirección de AI Search (Cloudflare)</label>
              <input style={s.input} value={form.ai_search_url} onChange={e => f('ai_search_url', e.target.value)} placeholder="https://....search.ai.cloudflare.com/search" />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>Cloudflare → AI Search → tu instancia → Public endpoint. Es lo que permite que el cliente describa lo que necesita con sus palabras. <b>Déjalo vacío para apagar el buscador por preguntas</b> — la tienda sigue funcionando igual con el buscador normal.</div>

              {/* Turnstile. La pública va escrita en la página de la tienda —así tiene que
                  ser—; la secreta se queda en el servidor y nunca sale hacia la tienda. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>🛡️ Turnstile — protección del formulario de pedidos</label>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,200px),1fr))', gap:'10px'}}>
                <input style={s.input} value={form.turnstile_site_key} onChange={e => f('turnstile_site_key', e.target.value)} placeholder="Site Key (pública) 0x4AAA..." />
                <input style={s.input} type="password" autoComplete="off" name="linkus_turnstile_secret" value={form.turnstile_secret} onChange={e => f('turnstile_secret', e.target.value)} placeholder={empresa?.tiene_turnstile_secret ? 'Ya hay una guardada — escribe una nueva solo si la vas a cambiar' : 'Secret Key (privada) 0x4AAA...'} />
              </div>
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>Cloudflare → Turnstile → tu widget. Evita que un robot te llene la tienda de pedidos falsos. La <b>Secret Key</b> no se muestra nunca después de guardarla; déjala vacía si no la vas a cambiar. <b>Ambas vacías = protección apagada</b> y el formulario funciona como siempre. Si Cloudflare no responde, el pedido pasa igual: perder una venta es peor que dejar entrar un pedido falso.</div>
              {/* Contar las visitas. Sin esto no hay forma de saber cuánta gente entra a la
                  tienda ni qué mira, y sin ese número no se puede decidir nada. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>📈 Contar visitas — Web Analytics (Cloudflare)</label>
              <input style={s.input} value={form.analytics_token} onChange={e => f('analytics_token', e.target.value)} placeholder="Token del sitio (32 letras y números)" />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>
                Cloudflare → <b>Analytics &amp; Logs</b> → <b>Web Analytics</b> → añade el sitio
                <b> linkustelecom.com</b>. Te da un fragmento de código; de ahí copia <b>solo el token</b>,
                que es lo que va entre comillas después de <code>"token":</code>. No usa galletas ni guarda
                quién es cada quien, así que no necesitas aviso de cookies. <b>Vacío = no se cuenta nada</b> y
                la página pesa exactamente lo mismo que antes.
              </div>
              {/* Lo que cobra la tienda por entregar. Hasta ahora estos numeros solo se podian
                  cambiar con SQL directo en el servidor, o sea que Victor no podia tocarlos.
                  Un flete no puede requerir un despliegue para subir. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>🚚 Entregas — qué cobra la tienda</label>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,200px),1fr))', gap:'10px'}}>
                <input style={s.input} value={form.envio_tarifa} onChange={e => f('envio_tarifa', e.target.value)} placeholder="Envío a otros municipios (15000)" inputMode="numeric" />
                <input style={s.input} value={form.envio_gratis_desde} onChange={e => f('envio_gratis_desde', e.target.value)} placeholder="Envío gratis desde (150000)" inputMode="numeric" />
              </div>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,200px),1fr))', gap:'10px', marginTop:'10px'}}>
                <input style={s.input} value={form.retiro_cargo} onChange={e => f('retiro_cargo', e.target.value)} placeholder="Cargo al reclamar en oficina (15000)" inputMode="numeric" />
                <input style={s.input} value={form.retiro_sin_cargo_pasando_de} onChange={e => f('retiro_sin_cargo_pasando_de', e.target.value)} placeholder="Sin ese cargo pasando de (50000)" inputMode="numeric" />
              </div>
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>
                Los dos primeros son para quien recibe por transportadora. Los dos últimos, para quien
                <b> reclama en la oficina en Santander de Quilichao</b>: paga ese cargo mientras el pedido
                no pase del tope, y deja de pagarlo <b>pasando de</b> esa cifra —los $50.000 exactos aún pagan—.
                Un <b>0</b> apaga el cobro de verdad; dejarlo <b>vacío</b> usa el valor de fábrica.
              </div>

              {/* El WhatsApp al que le escriben los clientes desde la tienda. El pedido se
                  guarda ANTES de abrir el chat, así que el mensaje ya cita su número de
                  pedido: el chat resuelve la duda, no reemplaza al sistema. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>💬 WhatsApp de ventas — botón en la tienda</label>
              <input style={s.input} value={form.whatsapp_ventas} onChange={e => f('whatsapp_ventas', e.target.value)} placeholder="3164137660" />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>
                El número al que le llegan los pedidos que el cliente prefiere coordinar por chat.
                Escríbelo como quieras —<b>3164137660</b>, <b>316 413 7660</b> o <b>+57 316 413 7660</b>—.
                El pedido queda guardado con su número <b>antes</b> de abrir el chat, así que igual te
                llega el correo y aparece en Pedidos Web. <b>Vacío = ese botón no aparece</b> en la tienda.
              </div>
              {/* Lectura de los avisos que mandan los proveedores por WhatsApp. Vacío =
                  apagado, y el alta de productos se llena a mano como siempre. */}
              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>✨ Leer fotos de proveedores — servicio de IA</label>
              {/* Se pide el numero de cuenta y no la direccion completa: la primera vez se
                  pegó la plantilla con el hueco sin llenar y Cloudflare contestó un 404
                  hablando de «object identifier», que no le dice nada a nadie. Un solo dato
                  que se copia de la barra del navegador es mucho más difícil de errar. */}
              <input style={s.input} value={form.ia_vision_url} onChange={e => f('ia_vision_url', e.target.value)} placeholder="Pega aquí tu número de cuenta de Cloudflare (32 letras y números)" />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'4px'}}>Lo sacas de la barra del navegador: entra a Cloudflare, haz clic en tu dominio y copia el código largo que queda entre las dos barras — <code style={{color:'#7DD3FC', overflowWrap:'anywhere'}}>dash.cloudflare.com/<b>ESTE_CODIGO</b>/linkustelecom.com</code>. Si usas otro servicio de IA, pega aquí la dirección completa empezando por https://</div>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,200px),1fr))', gap:'10px', marginTop:'10px'}}>
                <input style={s.input} type="password" autoComplete="off" name="linkus_ia_vision_token" value={form.ia_vision_token} onChange={e => f('ia_vision_token', e.target.value)} placeholder={empresa?.tiene_ia_vision_token ? 'Ya hay una guardada — escribe una nueva solo si la vas a cambiar' : 'Token del servicio'} />
                <input style={s.input} value={form.ia_vision_modelo} onChange={e => f('ia_vision_modelo', e.target.value)} placeholder="Modelo (ej: @cf/meta/llama-3.2-11b-vision-instruct)" />
              </div>
              <div style={{ display:'flex', gap:'10px', alignItems:'center', marginTop:'10px', flexWrap:'wrap' }}>
                <button style={s.btnProbar} onClick={probarLectura} disabled={probando}>
                  {probando ? 'Probando…' : '🔍 Probar la conexión'}
                </button>
                {/* Guardar primero: la prueba usa lo que hay en la base, no lo que está escrito
                    en pantalla. Sin este aviso, probar antes de guardar dice «falta el token»
                    con el token escrito ahí mismo, y no se entiende. */}
                <span style={{fontSize:'11px', color:'rgba(255,255,255,0.4)'}}>Prueba lo que está escrito arriba, sin necesidad de guardar.</span>
                {msgLectura?.licencia_pendiente && (
                  <button style={{...s.btnProbar, background:'rgba(34,197,94,0.14)', border:'1px solid rgba(34,197,94,0.4)', color:'#86EFAC'}}
                    onClick={aceptarLicencia} disabled={aceptando}>
                    {aceptando ? 'Aceptando…' : '✍️ Aceptar la licencia del modelo'}
                  </button>
                )}
              </div>
              {msgLectura && (
                <div style={{ marginTop:'10px', padding:'10px 12px', borderRadius:'8px', fontSize:'12px', lineHeight:'1.5',
                  background: msgLectura.ok ? 'rgba(34,197,94,0.12)' : 'rgba(239,68,68,0.1)',
                  color: msgLectura.ok ? '#86EFAC' : '#FCA5A5' }}>
                  {msgLectura.ok ? '✅ ' : '⚠️ '}{msgLectura.que_hacer}
                  {/* Las palabras exactas del servicio. Mi resumen dice qué hacer en el caso
                      corriente; cuando no es el corriente, lo único que sirve es el texto
                      original — y sin mostrarlo, la única forma de verlo era subir una foto. */}
                  {msgLectura.detalle && (
                    <details style={{ marginTop:'8px' }}>
                      <summary style={{ cursor:'pointer', color:'rgba(255,255,255,0.5)', fontSize:'11px' }}>Ver lo que respondió el servicio</summary>
                      <code style={{ display:'block', marginTop:'6px', fontSize:'11px', color:'rgba(255,255,255,0.6)', wordBreak:'break-all', lineHeight:'1.5' }}>{msgLectura.detalle}</code>
                    </details>
                  )}
                </div>
              )}
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>Con esto, en Catálogo → Nuevo producto puedes subir el aviso que te manda el proveedor por WhatsApp y el sistema saca el nombre y las características. <b>El precio no</b>: ese no viene en la imagen y lo escribes tú. El token no se muestra nunca después de guardarlo; déjalo vacío si no lo vas a cambiar. <b>Vacío = apagado</b> y el formulario se llena a mano.</div>

              <label style={{...s.label, color:'#4FC3F7', marginTop:'14px'}}>📧 Correos automáticos — usuario y clave del servidor de correo</label>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,200px),1fr))', gap:'10px'}}>
                <input style={s.input} value={form.gmail_user} onChange={e => f('gmail_user', e.target.value)} placeholder="Usuario (con Gmail, tucorreo@gmail.com)" />
                <input style={s.input} type="password" autoComplete="off" name="linkus_gmail_app_pass" value={form.gmail_app_pass} onChange={e => f('gmail_app_pass', e.target.value)} placeholder={empresa?.tiene_gmail_app_pass ? 'Ya hay una guardada — escribe una nueva solo si la vas a cambiar' : 'Clave (con Gmail, la de aplicación de 16 letras)'} />
              </div>
              {/* A dónde se conecta.
                  Estaba escrito en el código, y por eso el problema no tenía salida sin tocarlo:
                  DigitalOcean tiene cerrada la salida de correo del droplet por los puertos de
                  siempre (25, 465 y 587 se quedan esperando) y el 2525 sí abre. */}
              <div style={{display:'grid', gridTemplateColumns:'minmax(0,2fr) minmax(0,1fr)', gap:'10px', marginTop:'10px'}}>
                <input style={s.input} value={form.smtp_host} onChange={e => f('smtp_host', e.target.value)} placeholder="Servidor — vacío = Gmail (ej: smtp-relay.brevo.com)" />
                <input style={s.input} value={form.smtp_puerto} onChange={e => f('smtp_puerto', e.target.value)} placeholder="Puerto (2525)" inputMode="numeric" />
              </div>
              <input style={{...s.input, marginTop:'10px'}} value={form.smtp_remitente} onChange={e => f('smtp_remitente', e.target.value)} placeholder="Correo que ve el cliente como remitente — vacío = el usuario de arriba" />
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>
                <b>Déjalo vacío y sigue usando Gmail</b>, como hasta ahora. Se llena solo si hace falta salir
                por otro servidor: comprobado el 6-sep-2026 desde el servidor, DigitalOcean tiene cerrados los
                puertos <b>25, 465 y 587</b> —los de Gmail— y el <b>2525 sí abre</b>. Por eso hoy no sale ningún
                correo. Con un servicio de reenvío el usuario con el que te conectas no es el correo que debe ver
                el cliente, y por eso el remitente se pone aparte.
              </div>

              {/* Probar de verdad. Sin esto, la unica forma de saber si los correos salen era
                  hacer un pedido en la tienda y quedarse esperando — y si no llegaba, no habia
                  dónde mirar por qué. */}
              <div style={{ display:'flex', gap:'10px', alignItems:'center', marginTop:'10px', flexWrap:'wrap' }}>
                <button style={s.btnProbar} onClick={probarCorreo} disabled={probandoCorreo || guardando}>
                  {probandoCorreo ? 'Mandando…' : '📨 Probar el correo'}
                </button>
                {/* Aquí sí hay que guardar antes: la clave nunca viaja de vuelta a la pantalla,
                    así que la prueba solo puede usar la que está en la base. */}
                <span style={{fontSize:'11px', color:'rgba(255,255,255,0.4)'}}>Si acabas de cambiar la clave, guarda primero. Se manda a tu propio correo.</span>
              </div>
              {msgCorreo && (
                <div style={{ marginTop:'10px', padding:'10px 12px', borderRadius:'8px', fontSize:'12px', lineHeight:'1.5',
                  background: msgCorreo.ok ? 'rgba(34,197,94,0.12)' : 'rgba(239,68,68,0.1)',
                  color: msgCorreo.ok ? '#86EFAC' : '#FCA5A5' }}>
                  {msgCorreo.ok ? '✅ ' : '⚠️ '}{msgCorreo.que_hacer}
                </div>
              )}
              <div style={{fontSize:'11px', color:'rgba(255,255,255,0.4)', marginTop:'6px'}}>Con esto el sistema envía confirmaciones a los clientes y te avisa cada pedido nuevo. La contraseña de aplicación se crea en myaccount.google.com/apppasswords (requiere verificación en 2 pasos activa). <b>Si estos dos campos están vacíos no sale ningún aviso</b>, ni a ti ni al cliente.</div>
            </div>
          </div>
        </div>

        {/* Preview factura */}
        <div style={s.card}>
          <h3 style={s.cardTitulo}>👁 Vista previa del encabezado</h3>
          <div style={s.preview}>
            <div style={s.previewHeader}>
              {logoActual && <img src={logoActual} alt="logo" style={s.previewLogo} />}
              <div style={s.previewDatos}>
                <div style={s.previewNombre}>{form.nombre || 'Nombre de la empresa'}</div>
                {form.nit && <div style={s.previewInfo}>NIT: {form.nit}</div>}
                {form.telefono && <div style={s.previewInfo}>Tel: {form.telefono}{form.telefono2 ? ` / ${form.telefono2}` : ''}</div>}
                {form.direccion && <div style={s.previewInfo}>{form.direccion}{form.ciudad ? `, ${form.ciudad}` : ''}</div>}
                {form.email && <div style={s.previewInfo}>{form.email}</div>}
              </div>
            </div>
            <div style={s.previewLinea} />
            <div style={s.previewPie}>{form.pie_factura}</div>
          </div>
        </div>
      </div>

      {error && <div style={s.error}>⚠ {error}</div>}
      {ok && <div style={s.exito}>✅ Configuración guardada correctamente</div>}

      <div style={s.footer}>
        <button style={s.btnPrimario} onClick={guardar} disabled={guardando}>
          {guardando ? 'Guardando...' : '✓ Guardar configuración'}
        </button>
      </div>

      <div style={s.backupCard}>
        <div style={s.backupInfo}>
          <div style={s.backupIcono}>🗄</div>
          <div>
            <div style={s.backupTitulo}>Copia de seguridad</div>
            <div style={s.backupDesc}>Descarga o restaura un backup completo de la base de datos. Guárdalo en un lugar seguro regularmente.</div>
            {msgBackup && <div style={{ marginTop:'8px', fontSize:'13px', color: msgBackup.startsWith('✅') ? '#6EE7B7' : '#FCA5A5' }}>{msgBackup}</div>}
          </div>
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:'10px' }}>
          <button style={s.btnBackup} onClick={descargarBackup} disabled={descargando}>
            {descargando ? '⟳ Generando...' : '⬇ Descargar backup'}
          </button>
          <button style={{ ...s.btnBackup, background:'linear-gradient(135deg,#6366F1,#4F46E5)' }}
            onClick={() => inputBackupRef.current?.click()} disabled={restaurando}>
            {restaurando ? '⟳ Restaurando...' : '⬆ Restaurar backup'}
          </button>
          <input ref={inputBackupRef} type="file" accept=".dump" style={{ display:'none' }} onChange={restaurarBackup} />
        </div>
      </div>
    </Layout>
  );
}

const s = {
  header: { marginBottom:'28px' },
  titulo: { fontSize:'24px', fontWeight:'700', marginBottom:'4px' },
  sub: { color:'rgba(255,255,255,0.4)', fontSize:'14px' },
  // Dos columnas en el computador; en el celular, una. Con «1fr 1fr» fijo la tarjeta de los
  // datos medía 458 px dentro de una pantalla de 360 y arrastraba la barra de arriba.
  grid: { display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,340px),1fr))', gap:'16px', marginBottom:'20px' },
  card: { background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'16px', padding:'20px' },
  cardTitulo: { fontSize:'14px', fontWeight:'600', marginBottom:'16px', color:'rgba(255,255,255,0.8)' },
  logoArea: { display:'flex', flexDirection:'column', alignItems:'center', gap:'14px' },
  logoPreviewBox: { width:'120px', height:'120px', background:'rgba(255,255,255,0.06)', borderRadius:'12px', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' },
  logoPreviewImg: { maxWidth:'110px', maxHeight:'110px', objectFit:'contain' },
  logoVacio: { width:'120px', height:'120px', background:'rgba(255,255,255,0.04)', borderRadius:'12px', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'8px', border:'2px dashed rgba(255,255,255,0.1)' },
  logoVacioText: { fontSize:'12px', color:'rgba(255,255,255,0.3)' },
  logoBtns: { display:'flex', gap:'8px' },
  btnSubir: { background:'rgba(0,229,255,0.1)', border:'1px solid rgba(0,229,255,0.25)', borderRadius:'8px', padding:'8px 16px', color:'#00E5FF', fontSize:'13px', cursor:'pointer', fontWeight:'600' },
  btnProbar: { background:'rgba(168,85,247,0.12)', border:'1px solid rgba(168,85,247,0.35)', borderRadius:'8px', padding:'8px 16px', color:'#C084FC', fontSize:'13px', cursor:'pointer', fontWeight:'600' },
  btnEliminarLogo: { background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:'8px', padding:'8px 12px', color:'#FCA5A5', fontSize:'13px', cursor:'pointer' },
  logoHint: { fontSize:'11px', color:'rgba(255,255,255,0.3)', textAlign:'center', lineHeight:'1.5' },
  formGrid: { display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,160px),1fr))', gap:'12px' },
  campo: { display:'flex', flexDirection:'column', gap:'6px' },
  label: { color:'rgba(255,255,255,0.6)', fontSize:'12px' },
  input: { width:'100%', minWidth:0, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:'8px', padding:'9px 12px', color:'#fff', fontSize:'13px', outline:'none' },
  colorRow: { display:'flex', gap:'8px', alignItems:'center' },
  colorPicker: { width:'44px', height:'38px', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.12)', cursor:'pointer', padding:'2px', background:'rgba(255,255,255,0.06)' },
  preview: { background:'#fff', borderRadius:'10px', padding:'16px', color:'#1a1a2e' },
  previewHeader: { display:'flex', gap:'14px', alignItems:'flex-start', marginBottom:'10px' },
  previewLogo: { width:'60px', height:'60px', objectFit:'contain', borderRadius:'6px' },
  previewDatos: { flex:1 },
  previewNombre: { fontSize:'16px', fontWeight:'800', marginBottom:'4px', color:'#1a1a2e' },
  previewInfo: { fontSize:'11px', color:'#6b7280', lineHeight:'1.6' },
  previewLinea: { borderTop:'2px solid #1a1a2e', margin:'8px 0' },
  previewPie: { fontSize:'11px', color:'#9ca3af', textAlign:'center', fontStyle:'italic' },
  error: { background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:'8px', padding:'12px', color:'#FCA5A5', fontSize:'13px', marginBottom:'16px' },
  exito: { background:'rgba(16,185,129,0.1)', border:'1px solid rgba(16,185,129,0.25)', borderRadius:'8px', padding:'12px', color:'#6EE7B7', fontSize:'13px', marginBottom:'16px' },
  footer: { display:'flex', justifyContent:'flex-end' },
  btnPrimario: { background:'linear-gradient(135deg,#00E5FF,#6366F1)', border:'none', borderRadius:'10px', padding:'12px 28px', color:'#fff', fontSize:'14px', fontWeight:'600', cursor:'pointer' },
  backupCard: { display:'flex', flexWrap:'wrap', gap:'14px', justifyContent:'space-between', alignItems:'center', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'14px', padding:'20px 24px', marginTop:'20px' },
  backupInfo: { display:'flex', alignItems:'center', gap:'14px' },
  backupIcono: { fontSize:'32px' },
  backupTitulo: { fontSize:'15px', fontWeight:'600', marginBottom:'4px' },
  backupDesc: { fontSize:'13px', color:'rgba(255,255,255,0.4)' },
  btnBackup: { background:'linear-gradient(135deg,#10B981,#059669)', border:'none', borderRadius:'10px', padding:'10px 20px', color:'#fff', fontSize:'14px', fontWeight:'600', cursor:'pointer', whiteSpace:'nowrap' },
};
